import {useEffect} from "react";

export const useDrmPfInformationFont = () => {
    useEffect(() => {
        // コンポーネントがマウントされたときにクラスを追加
        document.body.classList.add('drmPfInformation-font');

        // コンポーネントがアンマウントされたときにクラスを削除
        return () => {
            document.body.classList.remove('drmPfInformation-font');
        };
    }, []);
}